import { withSvgIcon } from './withSvgIcon';

export const Upload = withSvgIcon(
  <path
    d="M6.5 10.5L12 5M12 5L17.5 10.5M12 5V15.6667M7 19H17"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
